import {
  useV1ProductionUnifiedConsumptionActionCreate,
  useV1ProductionUnifiedConsumptionActionBackflushSuggestionsList,
  useV1ProductionMaterialBalancesList
} from "@/api/generated/v1/v1";

export type {
  LotConversionAdjustmentInput,
  UnifiedConsumptionLineInput,
  BackflushSuggestionResult as BackflushSuggestion,
  MaterialBalanceResult,
} from "@/api/generated/models";

import type {
  UnifiedConsumptionLineInput,
} from "@/api/generated/models";

export function useSubmitUnifiedConsumptionAction() {
  const mutation = useV1ProductionUnifiedConsumptionActionCreate();
  return {
    ...mutation,
    mutateAsync: async (data: { work_order: string; lines: UnifiedConsumptionLineInput[] }) => {
      return mutation.mutateAsync({ data });
    }
  };
}

export function useBackflushSuggestions(workOrderId: string | null, actualProducedQuantity: string | null) {
  const enabled = Boolean(workOrderId && actualProducedQuantity);
  
  const query = useV1ProductionUnifiedConsumptionActionBackflushSuggestionsList(
    { work_order: workOrderId!, actual_produced_quantity: actualProducedQuantity! },
    { query: { enabled } }
  );

  return {
    enabled,
    fetcher: async () => {
      const res = await query.refetch();
      return { data: res.data };
    },
    data: query.data,
  };
}

export function useMaterialBalance(params: { work_order?: string | null }) {
  const enabled = Boolean(params.work_order);
  
  const query = useV1ProductionMaterialBalancesList(
    { work_order: params.work_order! },
    { query: { enabled } }
  );

  return {
    enabled,
    fetcher: async () => {
      const res = await query.refetch();
      return { data: res.data };
    },
    data: query.data,
  };
}
